import Swiper from 'swiper';
import { Parallax } from 'swiper/modules';

function init( node ) {
	const swiper = node.querySelector( '.gallery-slider__swiper' );
	const nextEl = node.querySelector( '.gallery-slider__next' );
	const prevEl = node.querySelector( '.gallery-slider__prev' );

	const inst = new Swiper( swiper, {
		modules: [ Parallax ],
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		parallax: true,
		speed: 1000,
		navigation: {
			nextEl,
			prevEl,
		},
	} );

	return inst;
}

document.querySelectorAll( '.gallery-slider' ).forEach( init );
